import {
  isInvoiceAmountFilterValid,
  type InvoiceFilterValues,
} from "@/domain/invoices/invoiceFilterState";
import type { CreateExportJobFromFiltersRequest } from "@/types/api";
import { isoDateToUnixEnd, isoDateToUnixStart } from "@/utils/format/isoDate";

function majorToMinorUnits(raw: string): number | undefined {
  const trimmed = raw.trim();
  if (!trimmed) return undefined;
  const n = Number(trimmed);
  if (!Number.isFinite(n)) return undefined;
  return Math.round(n * 100);
}

export type ExportNotifyOptions = {
  notifyEmailEnabled?: boolean;
  notifyEmailTo?: string;
};

export function buildExportFromFiltersRequest(
  filters: InvoiceFilterValues,
  options: {
    documentType?: "invoice_pdf" | "receipt" | "credit_note";
  } & ExportNotifyOptions = {},
): CreateExportJobFromFiltersRequest {
  const customer_ids =
    filters.customerIds.length > 0 ? filters.customerIds : undefined;
  const statuses =
    filters.statuses.length > 0 ? filters.statuses : undefined;
  const notifyEnabled = options.notifyEmailEnabled ?? false;
  const notifyTo = options.notifyEmailTo?.trim();

  return {
    customer_ids,
    statuses,
    created_from: isoDateToUnixStart(filters.dateFrom),
    created_to: isoDateToUnixEnd(filters.dateTo),
    due_from: isoDateToUnixStart(filters.dueDateFrom),
    due_to: isoDateToUnixEnd(filters.dueDateTo),
    ...(isInvoiceAmountFilterValid(filters.amountMin, filters.amountMax)
      ? {
          amount_due_min: majorToMinorUnits(filters.amountMin),
          amount_due_max: majorToMinorUnits(filters.amountMax),
        }
      : {}),
    document_type: options.documentType ?? "invoice_pdf",
    notify_email_enabled: notifyEnabled && Boolean(notifyTo),
    notify_email_to: notifyEnabled && notifyTo ? notifyTo : undefined,
  };
}
